<div class="cardLayout">
    <div class="d-flex flex-row align-items-center justify-content-between flex-wrap" style="gap: 8px">
        <div class="d-flex flex-row align-items-center psic-gap-2 flex-wrap" style="gap: 8px">
            <h4>{{ title }}</h4>
            <app-animation
                [class.d-none]="!isLoading"
                [src]="'dots_loader.json'"
                [loop]="true"
                [autoplay]="true"
            ></app-animation>
            @if (!isLoading) {
            <mat-icon
                svgIcon="reload"
                class="reload p1-50-color"
                (click)="retry.emit(); $event.stopPropagation()"
            ></mat-icon>
            } @if (failed) {
            <lib-alert
                style="width: fit-content"
                [alertText]="errorMessage"
                [alertTheme]="'error'"
                [alertType]="'small'"
            ></lib-alert>
            } @else if (!isLoading && !hasData) {
            <lib-alert
                style="width: fit-content"
                [alertText]="noDataMessage"
                [alertTheme]="'neutralBlue'"
                [alertType]="'small'"
            ></lib-alert>
            }
        </div>
        <ng-content select="[headerActions]"></ng-content>
    </div>

    @if (!failed && (isLoading || hasData)) {
    <ng-content></ng-content>
    }
</div>
